module.exports = __webpack_public_path__ + "static/media/049.10af03f3.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/049.wav
 ** module id = 181
 ** module chunks = 0
 **/